import Icon from '../../components/Icon.vue'

Icon.register({"brands/gitlab":{"width":512,"height":512,"paths":[{"d":"M29.8 199.7L256 493.7 8.1 309.7C1.2 304.6-1.6 295.7 0.9 287.7L29.8 199.7zM105.2 24.9C102 16.1 89.5 16.1 86.3 24.9L29.8 199.7H161.7L105.2 24.9zM161.7 199.7L256 493.7 350.3 199.7H161.7zM511.1 287.7L482.2 199.7 256 493.7 503.9 309.7C510.8 304.6 513.6 295.7 511.1 287.7zM425.7 24.9C422.5 16.1 410 16.1 406.8 24.9L350.3 199.7H482.2L425.7 24.9z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/gitlab.js
// module id = ykc9
// module chunks = 0